"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var column_view_model_1 = require("../../model/column-view.model");
var idm_reporting_service_client_js_1 = require("@synisys/idm-reporting-service-client-js");
var idm_dataset_service_client_js_1 = require("@synisys/idm-dataset-service-client-js");
var idm_report_export_service_client_js_1 = require("@synisys/idm-report-export-service-client-js");
var TreeViewManager = /** @class */ (function () {
    function TreeViewManager() {
    }
    /**
     * Add node on tree on specified position.
     * @param {CategoryPathDto} pathDto category path holder.
     * @param {ColumnView} node Node on which position node must be added
     */
    TreeViewManager.replaceCategoryNode = function (pathDto, node) {
        this.replaceNode(new idm_reporting_service_client_js_1.ColumnCategoryBuilder(pathDto.id).setShowOnRowsTotal(false).getElement(), node);
    };
    /**
     * Add node on tree on specified position.
     * @param {MeasurePathDto} pathDto measure path holder .
     * @param {ColumnView} node Node on which position node must be added
     */
    TreeViewManager.replaceMeasureNode = function (pathDto, node) {
        var showOnRowsTotal = pathDto.measurePathType === idm_dataset_service_client_js_1.MeasurePathType.MONEY ||
            pathDto.measurePathType === idm_dataset_service_client_js_1.MeasurePathType.NUMBER;
        this.replaceNode(new idm_reporting_service_client_js_1.ColumnMeasureBuilder(pathDto.id).setShowOnRowsTotal(showOnRowsTotal).getElement(), node);
    };
    /**
     * Add node on tree on specified position.
     * @param {AbstractTreeElementDto} element Abstract Tree element dto.
     * @param {ColumnView} node Node on which position node must be added
     */
    TreeViewManager.replaceNode = function (element, node) {
        var tree = TreeViewManager.getRootNode(node);
        var el = new column_view_model_1.ColumnView(element, false, true);
        var index = node.index;
        var parent = node.parent;
        if (!parent) {
            throw new Error('Not allow to replace root node.');
        }
        if (!(node.isNew || node.isDefaultNew || node.isGoingToReplace)) {
            throw new Error('Replaced node must be temporary or selected to replace.');
        }
        tree.cleanAnimatedFlags();
        tree.cleanCreatedFlags();
        tree.setBeforeCreatedFlags();
        tree.cleanActiveFlags();
        tree.cleanSelectedFlags();
        tree.removeTemporaryNodes();
        tree.recalculateIndexes();
        if (node.isNew || node.isDefaultNew) {
            parent.addWithIndex(el, index);
        }
        else if (node.isGoingToReplace) {
            node.element = element;
            if (element instanceof idm_reporting_service_client_js_1.ColumnCategoryDto) {
                node.columnStyleDto = new idm_report_export_service_client_js_1.ColumnCategoryStyleDto();
            }
            else if (element instanceof idm_reporting_service_client_js_1.ColumnMeasureDto) {
                node.columnStyleDto = new idm_report_export_service_client_js_1.ColumnMeasureStyleDto();
            }
        }
        tree.recalculateIndexes();
    };
    TreeViewManager.addTempNodes = function (node, onChild, onSibling) {
        if (onChild === void 0) { onChild = true; }
        if (onSibling === void 0) { onSibling = true; }
        // figure out is sibling node is default-new node
        var siblingNode = node.parent.children[node.index + 1];
        var isSiblingDefaultNew = siblingNode && siblingNode.isDefaultNew;
        // add temporary new nodes on child and/or on sibling position
        this.addTempNodesOn(node, onChild, onSibling && !isSiblingDefaultNew);
    };
    /**
     * Add temporary nodes on tree
     * @param {ColumnView} node Node to be activated
     * @param {boolean} onChild Flag to indicate whether add temporary node on child position of activated node.
     * @param {boolean} onSibling Flag to indicate whether add temporary node on sibling position of activated node.
     */
    TreeViewManager.addTempNodesOn = function (node, onChild, onSibling) {
        var tree = TreeViewManager.getRootNode(node);
        tree.clean();
        // set before new flags to node's subtree's right node in each level.
        if (onChild || onSibling) {
            var child = node;
            child.isBeforeNew = true;
            while (child.children.length > 0) {
                child = child.children[child.children.length - 1];
                child.isBeforeNew = true;
            }
        }
        if (onChild) {
            var columnView = new column_view_model_1.ColumnView(null, true);
            columnView.isBeforeNew = (node.children.length === 0); // set before-new flag to node when parent has't any other children
            node.add(columnView);
        }
        if (onSibling) {
            node.parent.addWithIndex(new column_view_model_1.ColumnView(null, true), node.index + 1);
        }
        else {
            node.parent.children[node.index + 1].isDefaultNewWide = true;
        }
        if (onChild || onSibling) {
            node.isActive = true;
            tree.recalculateIndexes();
        }
    };
    TreeViewManager.removeNode = function (node, removeSubTree) {
        var tree = TreeViewManager.getRootNode(node);
        var index = node.index;
        var parent = node.parent;
        if (!parent) {
            throw new Error('Not allow to remove root node.');
        }
        tree.cleanCreatedFlags();
        node.isRemoved = true;
        if (removeSubTree) {
            node.setRemovedFlagOnChildren();
        }
        tree.recalculateIndexes();
    };
    /**
     * Get root node of tree.
     * @param {ColumnView} node Any node in tree.
     * @returns {ColumnView}    Root node of tree.
     */
    TreeViewManager.getRootNode = function (node) {
        var root = node;
        while (root.parent) {
            root = root.parent;
        }
        return root;
    };
    TreeViewManager.getNodesByLevel = function (tree, levelIndex) {
        if (levelIndex === 0) {
            return tree.children ? tree.children : [];
        }
        var count = [];
        if (tree.children) {
            for (var i = 0; i < tree.children.length; i++) {
                var items = this.getNodesByLevel(tree.children[i], levelIndex - 1);
                for (var k = 0; k < items.length; k++) {
                    count.push(items[k]);
                }
            }
        }
        return count;
    };
    TreeViewManager.calculateDepth = function (tree) {
        var depth = 0;
        if (tree.children) {
            for (var i = 0; i < tree.children.length; i++) {
                var childDepth = this.calculateDepth(tree.children[i]);
                if (childDepth > depth) {
                    depth = childDepth;
                }
            }
        }
        return depth + 1;
    };
    TreeViewManager.getColSpan = function (tree) {
        if (tree.children.length === 0) {
            return 1;
        }
        var colSpan = 0;
        for (var _i = 0, _a = tree.children; _i < _a.length; _i++) {
            var child = _a[_i];
            colSpan += this.getColSpan(child);
        }
        return colSpan;
    };
    TreeViewManager.getRowSpan = function (tree, level, depth) {
        if (tree.children.length > 0) {
            return 1;
        }
        return depth - level;
    };
    TreeViewManager.getLeafNodes = function (tree) {
        var nodes = [];
        if (tree.children.length === 0) {
            nodes.push(tree);
            return nodes;
        }
        for (var i = 0; i < tree.children.length; i++) {
            var childLeafNodes = this.getLeafNodes(tree.children[i]);
            childLeafNodes.forEach(function (node) {
                nodes.push(node);
            });
        }
        return nodes;
    };
    /**
     * Fetch path id of specified tree node.
     * @param {ColumnView} node Tree node.
     * @returns {number}    Path id of specified node.
     */
    TreeViewManager.fetchPathId = function (node) {
        var element = node.element;
        if (element instanceof idm_reporting_service_client_js_1.ColumnCategoryDto) {
            return element.categoryElementDto.categoryPathHolderId;
        }
        else if (element instanceof idm_reporting_service_client_js_1.ColumnMeasureDto) {
            return element.measurePathHolderId;
        }
        else if (element instanceof idm_reporting_service_client_js_1.RowCategoryDto) { // TODO: no element is instance of RowCategoryDto
            return element.categoryElementDto.categoryPathHolderId;
        }
        else {
            throw new Error('Unknown AbstractTreeElementDto');
        }
    };
    /**
     * Fetch tree branch path ids.
     * @param {ColumnView} node Tree node
     * @returns {Array<number>} Array of path ids in specified node's branch.
     */
    TreeViewManager.fetchBranchPathIds = function (node) {
        var pathIds = [];
        if (node.element != null) {
            pathIds.push(this.fetchPathId(node));
        }
        if (node.parent != null) {
            pathIds.push.apply(pathIds, this.fetchBranchPathIds(node.parent));
        }
        return pathIds;
    };
    /**
     * Fetch branch nodes of specified tree node.
     * @param {ColumnView} node Tree node.
     * @returns {Array<ColumnView>} Array of nodes in specified branch.
     */
    TreeViewManager.fetchBranchNodes = function (node) {
        var nodes = [];
        if (node.element != null) {
            nodes.push(node);
        }
        if (node.parent != null) {
            nodes.push.apply(nodes, this.fetchBranchNodes(node.parent));
        }
        return nodes;
    };
    /**
     * Fetch sub tree path ids.
     * @param {ColumnView} node Tree node
     * @returns {Array<number>} Array of path ids in specified node's sub tree.
     */
    TreeViewManager.fetchSubTreePathIds = function (node) {
        var _this = this;
        var pathIds = [];
        if (node.element != null) {
            pathIds.push(this.fetchPathId(node));
        }
        node.children.forEach(function (child) {
            pathIds.push.apply(pathIds, _this.fetchSubTreePathIds(child));
        });
        return pathIds;
    };
    /**
     * Fetch sub tree nodes of specified tree node.
     * @param {ColumnView} node Tree node.
     * @returns {Array<ColumnView>} Array of nodes in specified node's sub tree.
     */
    TreeViewManager.fetchSubTreeNodes = function (node) {
        var _this = this;
        var nodes = [];
        if (node.element != null) {
            nodes.push(node);
        }
        node.children.forEach(function (child) {
            nodes.push.apply(nodes, _this.fetchSubTreeNodes(child));
        });
        return nodes;
    };
    return TreeViewManager;
}());
exports.TreeViewManager = TreeViewManager;
//# sourceMappingURL=tree-view-manager.js.map